































































































































































































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/types";
import * as statusConst from "@/store/constants/status";
import GeneralUtilsHelper from "@/utils/generalUtils";
import VipButton from "@/views/more/moreVipEntrance/MoreVipEntranceButton.vue";
@Component({
  components: {
    VipButton
  }
})
export default class ButtonGroup extends Vue {
  @Prop({ default: "" })
  private status!: string;
  @Prop({ default: 0 })
  private skipDelayCountNum!: number;
  @Prop({ default: 0 })
  private earnFeedSpacingCountNum!: number;
  @Getter(types.GETTER_CURRENT_FEED)
  private currentFeed: any;
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Getter(types.GETTER_SETTING_DATA)
  private settginData: any;
  @Getter(types.GETTER_EARN_COIN_USER_LIST)
  private earnCoinUserList: any;
  @Getter(types.GETTER_SUPER_PAY_APP_CONFIG)
  private superPayAppConfig: any;
  @Getter(types.GETTER_BACK_UP_APP_CONFIG)
  private backUpAppConfig: any;
  @Getter(types.GETTER_SUPER_PAY_APP_HAS_INSTALLED)
  private superPayAppHasInstalled: any;
  @Getter(types.GETTER_BACK_UP_APP_HAS_INSTALLED)
  private backUpAppHasInstalled: any;
  @Action(types.SHAKE_PLAY)
  private shakePlay: any;
  @Prop({
    default: () => {
      return {
        kind: "",
        offer_id: ""
      };
    }
  })
  private offer: any;
  @Prop({ default: 1 })
  private randomFeedCoinsStatus!: number;

  private animationStyle: any = { animation: "rubberBand 1s" };

  @Watch("feedOfferShow", { immediate: true })
  private feedCoinShowWatch(val: any, oldVal: any) {
    if (val) {
      setTimeout(() => {
        this.animationStyle = { animation: "tadaHalfDelay 4s infinite" };
        if (this.shakeAction) {
          setTimeout(() => {
            this.shakePlay(20, 0);
          }, 2000);
        }
      }, 1200);
    } else {
      this.animationStyle = { animation: "rubberBand 1s" };
    }
  }

  get speedWrappeShow() {
    return (
      !this.feedLuckyCoinsShow && !this.feedSuperPayShow && !this.feedBackUpShow
    );
  }

  get rotateDeg() {
    return {
      transform: `rotate(${20 * this.workingUserListLength}deg)`
    };
  }

  get localizePriceText() {
    return GeneralUtilsHelper.localizePriceText;
  }

  get feedCoinText() {
    return this.localizePriceText(this.offer);
  }

  get feedCoinsPriceShow() {
    if (this.randomFeedCoinsStatus < 3) {
      return true;
    } else {
      return false;
    }
  }

  get luckyCoinOffer() {
    return (
      this.settingData &&
      this.settingData.lucky_coin_offers &&
      this.settingData.lucky_coin_offers[0]
    );
  }

  get earnFeedSpacingShow() {
    return this.earnFeedSpacingCountNum > 0;
  }

  get luckyCoinPrice() {
    return this.localizePriceText(this.luckyCoinOffer);
  }

  get vipOffer() {
    return this.settginData.hasOwnProperty("service_offers")
      ? this.settginData.service_offers[0]
      : {};
  }

  get watchVideoReward() {
    return this.settingData.rewards.video;
  }

  get feedNormalShow() {
    return this.status === statusConst.FEED_NORMAL ? true : false;
  }

  get superPayShowReward() {
    return this.isLoginUser && !this.superPayAppHasInstalled;
  }

  get backUpShowReward() {
    return this.isLoginUser && !this.backUpAppHasInstalled;
  }

  get superPayText() {
    return this.superPayShowReward && this.superPayAppConfig.reward
      ? `GET +${this.superPayAppConfig.reward}`
      : `GET NOW`;
  }

  get backUpText() {
    return this.backUpShowReward && this.backUpAppConfig.reward
      ? `GET +${this.backUpAppConfig.reward}`
      : `GET NOW`;
  }

  get feedEmptyShow() {
    return this.status === statusConst.FEED_EMPTY ? true : false;
  }

  get feedCoinShow() {
    return this.status === statusConst.FEED_COIN ? true : false;
  }

  get casinoSpinShow() {
    //转盘
    return this.status === statusConst.FEED_CASINO_SPIN ? true : false;
  }

  get casinoSlotShow() {
    //老虎机是否显示
    return this.status === statusConst.FEED_CASINO_SLOTS ? true : false;
  }

  get casinoSicShow() {
    //筛子
    return this.status === statusConst.FEED_CASINO_SIC ? true : false;
  }

  get feedAdsShow() {
    //显示广告
    return this.status === statusConst.FEED_AD ? true : false;
  }

  get feedSuperPayShow() {
    return this.status === statusConst.FEED_SUPER_PAY;
  }

  get feedBackUpShow() {
    return this.status === statusConst.FEED_BACK_UP;
  }

  get feedLuckyCoinsShow() {
    //lucky
    return this.status === statusConst.FEED_LUCKY_COIN ? true : false;
  }

  get feedVipShow() {
    return this.status === statusConst.FEED_VIP ? true : false;
  }

  get casinoShow() {
    return this.casinoSlotShow || this.casinoSicShow || this.casinoSpinShow;
  }

  get feedOfferShow() {
    return (
      this.casinoShow ||
      this.feedCoinShow ||
      this.feedVipShow ||
      this.feedLuckyCoinsShow ||
      this.feedAdsShow ||
      this.feedSuperPayShow ||
      this.feedBackUpShow
    );
  }

  get shakeAction() {
    return this.feedCoinShow || this.feedVipShow || this.feedLuckyCoinsShow;
  }

  get turboMoreShow() {
    return !this.feedOfferShow;
  }

  get casinoClass() {
    if (this.casinoSpinShow) {
      return "spin";
    } else if (this.casinoSlotShow) {
      return "slot";
    } else if (this.casinoSicShow) {
      return "sic";
    } else {
      return "";
    }
  }

  get bottomText() {
    if (this.status === statusConst.FEED_COIN) {
      return `<span
      style='font-family: WorkSans-Bold,AppleSDGothicNeo-Bold;font-size:12px;line-height:12px'
      >${this.offer.discount}</span><i
      style='font-family: WorkSans-SemiBold,AppleSDGothicNeo-Bold;font-size:8px;line-height:12px'
      >%OFF</i>`;
    } else if (
      this.casinoSlotShow ||
      this.casinoSicShow ||
      this.casinoSpinShow
    ) {
      //赌场
      return "Casino";
    } else if (this.feedVipShow) {
      return "Benefits";
    } else {
      return this.workingUserListLength + ".0x";
    }
  }

  get typeName() {
    if (this.currentFeed) {
      switch (this.currentFeed.sub_kind) {
        case "follow": {
          return "FOLLOW";
        }
        case "like": {
          return "LIKE";
        }
        case "comment": {
          return "COMMENT";
        }
        default: {
          return "FOLLOW";
        }
      }
    } else {
      return "";
    }
  }

  get feedCoinLevel() {
    try {
      if (
        this.offer &&
        this.offer.kind &&
        this.offer.kind.indexOf("vip") > -1
      ) {
        return "level_vip";
      }

      // const { feed_coin_offers } = this.settginData;
      // let newFeedCoinsArr = feed_coin_offers.filter((feed: any) => {
      //   return feed.kind === "feed_coin";
      // });

      // newFeedCoinsArr = this.bubbleSort(newFeedCoinsArr);

      // for (const i in newFeedCoinsArr) {
      //   if (newFeedCoinsArr[i].offer_id === this.offer.offer_id) {
      //     return `level_${parseInt(i) + 1}`;
      //   }
      // }
      return `level_${this.randomFeedCoinsStatus}`;
    } catch (error) {
      console.log("feedCoinLevel error:", error);
    }
  }

  private bubbleSort = (arr: any) => {
    const len = arr.length;
    for (let i = 0; i < len; i++) {
      for (let j = 0; j < len - 1 - i; j++) {
        if (arr[j].effect > arr[j + 1].effect) {
          //相邻元素两两对比
          const temp = arr[j + 1]; //元素交换
          arr[j + 1] = arr[j];
          arr[j] = temp;
        }
      }
    }
    return arr;
  };

  get limitedStatusShow() {
    return this.status === statusConst.TIME_LIMIT ? true : false;
  }

  get cancelButtonShow() {
    return this.status === statusConst.NEED_LOGIN ||
      this.status === statusConst.FEED_EMPTY ||
      this.status === statusConst.TIME_LIMIT ||
      this.skipDelayCountNum > 0
      ? false
      : true;
  }

  get rightButtonShow() {
    if (this.feedAdsShow || this.skipDelayCountNum > 0) {
      return false;
    } else {
      return true;
    }
  }

  get isLoginUser() {
    return GeneralUtilsHelper.isLoginUser();
  }

  get workingUserList() {
    return this.earnCoinUserList("working");
  }

  get workingUserListLength() {
    return this.workingUserList ? this.workingUserList.length : 0;
  }

  get rewardCoinsEffect() {
    console.log("this.workingUserList:", this.workingUserList);
    return this.currentFeed
      ? this.currentFeed.coins *
          (this.workingUserListLength === 0 ? 1 : this.workingUserListLength)
      : void 0;
  }

  private clickLeft() {
    this.$emit("clickLeft");
  }
  private clickMid() {
    if (!this.earnFeedSpacingShow) {
      this.$emit("clickMid");
    }
  }
  private clickRight() {
    this.$emit("clickRight");
  }
}
